<template>
    <v-list :nav="true" density="compact">
        <v-list-item>
            <template v-if="$vuetify.display.lgAndUp" #prepend>
                <v-icon icon="mdi-menu" style="font-size: 24px; height: 24px; width: 24px" @click="$emit('mini-variant-changed', !isMiniVariant)" />
            </template>

            <v-list-item-title>
                <router-link :to="{ name: 'Home' }">
                    <div style="height: 32px; width: 127px">
                        <v-img v-if="!isMiniVariant" src="../assets/vetdata-Logo.jpg"></v-img>
                    </div>
                </router-link>
            </v-list-item-title>
        </v-list-item>
        <v-divider class="mb-2"></v-divider>
        <template v-if="loggedIn">
            <v-list-item
                v-if="hasAccess('Navigation.Kontobrowser')"
                link
                class="mb-2"
                prepend-icon="mdi-home-account"
                :to="{ name: 'Home' }"
                :title="$t('navigation.tvskonto')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.Lieferantenrechnung')"
                class="mb-2"
                link
                prepend-icon="mdi-format-list-bulleted"
                :to="{ name: 'Lieferantenrechnungen' }"
                :title="$t('navigation.lieferantenrechnung')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.Praxisgrupperechnungen')"
                class="mb-2"
                link
                prepend-icon="mdi-format-list-bulleted"
                :to="{ name: 'PraxisgruppeRechnungen' }"
                :title="$t('navigation.praxisgruppe.rechnungen')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.PraxisgruppeTeilnehmerAdministration')"
                class="mb-2"
                link
                prepend-icon="mdi-account-search"
                :to="{ name: 'PraxisgruppeTeilnehmerAdministration' }"
                :title="$t('navigation.praxisgruppe.teilnehmeradministration')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.PraxisgruppeEinstellungen')"
                class="mb-2"
                link
                prepend-icon="mdi-account-cog"
                :to="{ name: 'PraxisgruppeEinstellungen' }"
                :title="$t('navigation.praxisgruppe.einstellungen')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.Dokumentarchiv')"
                link
                prepend-icon="mdi-magnify"
                :to="{ name: 'Dokumentarchiv' }"
                :title="$t('navigation.dokumentarchiv')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.Dokumentupload')"
                link
                prepend-icon="mdi-upload"
                :to="{ name: 'Dokumentupload' }"
                :title="$t('navigation.dokumentupload')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.Benutzereinstellungen')"
                link
                prepend-icon="mdi-account-cog"
                :to="{ name: 'Einstellungen' }"
                :title="$t('navigation.einstellungen')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.TeilnehmerAdministration')"
                link
                prepend-icon="mdi-account-search"
                :to="{ name: 'TeilnehmerAdmin' }"
                :title="$t('navigation.teilnehmeradmin')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.BenutzerSuche')"
                link
                prepend-icon="mdi-account-search"
                :to="{ name: 'BenutzerSuche' }"
                :title="$t('navigation.benutzerSuche')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.VetpointDaten')"
                link
                prepend-icon="mdi-format-list-bulleted"
                :to="{ name: 'VetpointDaten' }"
                :title="$t('vetpointdaten.title')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.FehlerhafteRechnungen')"
                link
                prepend-icon="mdi-file-cancel"
                :to="{ name: 'FehlerhafteRechnungen' }"
                :title="$t('navigation.fehlerhafteRechnungen')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.TreuhandTeilnehmerListe')"
                link
                prepend-icon="mdi-format-list-bulleted"
                :to="{ name: 'TreuhandTeilnehmerListe' }"
                :title="$t('navigation.TreuhandTeilnehmerListe')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.TreuhandEinstellungen')"
                link
                prepend-icon="mdi-account-cog"
                :to="{ name: 'TreuhandEinstellungen' }"
                :title="$t('navigation.TreuhandEinstellungen')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.TvsKundenListe')"
                link
                prepend-icon="mdi-account-search"
                :to="{ name: 'TvsKundenListe' }"
                :title="$t('navigation.TvsKundenListe')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.LieferantRechnungen')"
                link
                prepend-icon="mdi-format-list-bulleted"
                :to="{ name: 'LieferantRechnungen' }"
                :title="$t('navigation.LieferantRechnungen')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.LieferantFehlerhafteRechnungen')"
                link
                prepend-icon="mdi-file-cancel"
                :to="{ name: 'LieferantFehlerhafteRechnungen' }"
                :title="$t('navigation.LieferantFehlerhafteRechnungen')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.LieferantRechnungen')"
                link
                prepend-icon="mdi-form-textbox"
                :to="{ name: 'LieferantRechnungFormular' }"
                :title="$t('navigation.LieferantRechnungFormular')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.LieferantDokumentArchiv')"
                link
                prepend-icon="mdi-file-multiple"
                :to="{ name: 'LieferantDokumentArchiv' }"
                :title="$t('navigation.LieferantDokumentArchiv')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.LieferantEinstellungen')"
                link
                prepend-icon="mdi-account-cog"
                :to="{ name: 'LieferantEinstellungen' }"
                :title="$t('navigation.LieferantEinstellungen')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.AdminLieferantDokumentArchiv')"
                link
                prepend-icon="mdi-file-multiple"
                :to="{ name: 'AdminLieferantDokumentArchiv' }"
                :title="$t('navigation.AdminLieferantDokumentArchiv')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.LieferantDokumentUpload')"
                link
                prepend-icon="mdi-upload"
                :to="{ name: 'LieferantenDokumentUpload' }"
                :title="$t('navigation.lieferantenDokumentUpload')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.Konfiguration')"
                link
                prepend-icon="mdi-cog"
                :to="{ name: 'Konfiguration' }"
                :title="$t('navigation.Konfiguration')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
            <v-list-item
                v-if="hasAccess('Navigation.TakeTeilnehmer')"
                link
                prepend-icon="mdi-account-convert"
                :to="{ name: 'TakeTeilnehmer' }"
                :title="$t('navigation.TakeTeilnehmer')"
                @click="setAccessDenied(false)"
            >
            </v-list-item>
        </template>
    </v-list>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator';

import { namespace } from 'vuex-facing-decorator';

import { NAME as NAME_SECURITY } from '@/store/modules/security';
const securityModul = namespace(NAME_SECURITY);

import { ISLOGGEDIN, HASACCESS } from '@/store/modules/security/getters';
import { LOGOUT } from '@/store/modules/security/actions';
import { SETACCESSDENIED } from '@/store/modules/security/mutations';

@Component({
    emits: ['mini-variant-changed'] // Declare the emitted event here
})
export default class Navigation extends Vue {
    @Prop({ required: false, type: Boolean, default: false })
    private isMiniVariant!: boolean;
    @securityModul.Action(LOGOUT) logout!: Function;
    @securityModul.Getter(ISLOGGEDIN) loggedIn!: boolean;
    @securityModul.Getter(HASACCESS) hasAccess!: Function;
    @securityModul.Mutation(SETACCESSDENIED) setAccessDenied!: Function;
}
</script>
<style scoped>
.v-list-item {
    text-align: left !important;
}
</style>
